export const JOB_CARDS_SLICE_NAME = 'jobCards';
export const REQUEST_SLICE_NAME = 'request';
export const LOCATION_SLICE_NAME = 'location';
export const ALERTS_SLICE_NAME = 'alerts';
export const JOB_DETAIL_SLICE_NAME = 'jobDetail';
export const JOB_SCHEDULE_SLICE_NAME = 'jobSchedule';
export const FEATURE_FLAG_SLICE_NAME = 'featureFlag';
